import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.checkOverflow()

    this.boundCheckOverflow = () => this.checkOverflow()

    window.addEventListener('resize', this.boundCheckOverflow)
  }

  disconnect() {
    window.removeEventListener('resize', this.boundCheckOverflow)
  }

  checkOverflow() {
    const hasOverflow = this.element.scrollWidth > this.element.clientWidth

    this.element.classList.toggle('overflowing', hasOverflow)
  }
}
